import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {createStore, applyMiddleware} from "redux";
import {Provider} from "react-redux"
import rootReducer from "./store/reduceers/rootReducer";
import thunk from "redux-thunk" // allow asynchronous actions
import logger from "redux-logger";
import {translations} from './translations';
import {IntlProvider} from 'react-redux-multilingual';
import {DEFAULT_LANG} from "./config";

// Here is list of middlewares  applied in development...
const applied_middleware = process.env.NODE_ENV === 'development' ? applyMiddleware(logger,  thunk) : applyMiddleware(thunk);

const store = createStore(
    rootReducer,
   { Intl: { locale: localStorage.getItem("seenaLang") ? localStorage.getItem("seenaLang") :  DEFAULT_LANG}},
    applied_middleware,
);

ReactDOM.render(
    <Provider store={store}>
        <IntlProvider translations={translations}>
            <App />
        </IntlProvider>
    </Provider>, document.getElementById('root'));

serviceWorker.unregister();

